import "./src/styles/global.scss"
import React from 'react';
import { UtmProvider } from './src/contexts/utmProvider';
import { CookieProvider } from "./src/contexts/cookieProvider";

export const wrapRootElement = ({ element }) => (
  <CookieProvider><UtmProvider>{element}</UtmProvider></CookieProvider>
);